/**
 *
 * @module zipLocation
 *
 */

import Check from 'check-types';
import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    nonEmptyString
} = Check.assert;

/**
 *
 * @class ZipLocation
 *
 */
export default class ZipLocation {

    /**
     *
     * @param {String} city
     * @param {String} state
     * @param {String} country
     * @throws {InvalidArgumentException}
     *
     */
    constructor(city, state, country) {

        const errorMessage = {
            ctor: 'Location(city, state, country)',
            get city() {
                return `${this.ctor} city should be a String with length`;
            },
            get state() {
                return `${this.ctor} state should be a String with length`;
            },
            get country() {
                return `${this.ctor} country should be a String with length`;
            }
        };

        nonEmptyString(city, errorMessage.city, InvalidArgumentException);
        nonEmptyString(state, errorMessage.state, InvalidArgumentException);
        nonEmptyString(country, errorMessage.country, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.city = city;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.state = state;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.country = country;

    }

}



// WEBPACK FOOTER //
// ./src/services/commerce/zipLocation.js